// Турецкая диктовка (use-voice-input.ts): распознавание Chrome и Android само
// пишет сказанные числа цифрами ("saat 9.00'a 37 var"), а репетитор и проверка
// фраз считают цифры ошибкой: ученик сказал "dokuza otuz yedi", а в поле цифры
// (владелец 15.10.2026). Возвращаем числа словами, как они прозвучали.
//
// - время "9.00", "9:30", "09.05" - часы словом, минуты словом ("00" не читается,
//   "05" - "sıfır beş");
// - "1.000", "25.000" - точка отделяет тысячи;
// - "3,5" - "üç virgül beş", "%50" - "yüzde elli";
// - аффикс через апостроф пристёгивается к слову: "9.00'a" -> "dokuza",
//   "37'yi" -> "otuz yediyi" (распознавание уже подобрало его по звучанию).
// Числа от миллиона и больше остаются цифрами.
import { numberToTr } from './numbers-tr'

const MAX = 999_999

function intToTr(digits: string): string | null {
  const n = Number(digits)
  if (!Number.isFinite(n) || n > MAX) return null
  return n === 0 ? 'sıfır' : numberToTr(n)
}

function minutesToTr(mm: string): string {
  if (mm === '00') return ''
  if (mm[0] === '0') return `sıfır ${numberToTr(Number(mm[1]))}`
  return numberToTr(Number(mm))
}

const NUMBER = /(%\s?)?(\d{1,3}(?:\.\d{3})+|\d{1,2}[.:]\d{2}(?!\d)|\d+(?:,\d+)?)(?:['’](\p{L}+))?/gu

export function spokenNumbersToTr(text: string): string {
  return text.replace(NUMBER, (whole, percent: string | undefined, num: string, suffix: string | undefined) => {
    let words: string | null = null
    const time = /^(\d{1,2})[.:](\d{2})$/.exec(num)
    if (time && Number(time[1]) <= 24 && Number(time[2]) < 60) {
      const hour = intToTr(time[1])
      words = hour && [hour, minutesToTr(time[2])].filter(Boolean).join(' ')
    } else if (/^\d{1,3}(?:\.\d{3})+$/.test(num)) {
      words = intToTr(num.replace(/\./g, ''))
    } else if (num.includes(',')) {
      const [a, b] = num.split(',')
      const left = intToTr(a)
      // Дробную часть читают числом с ведущими нулями: 0,05 - "sıfır virgül sıfır beş".
      const zeros = b.match(/^0*/)![0].length
      const right = zeros === b.length ? Array(zeros).fill('sıfır').join(' ') : [...Array(zeros).fill('sıfır'), intToTr(b.slice(zeros))].join(' ')
      words = left && b.length <= 6 ? `${left} virgül ${right}` : null
    } else {
      words = intToTr(num)
    }
    if (!words) return whole
    return `${percent ? 'yüzde ' : ''}${words}${suffix ?? ''}`
  })
}
